import React, { Component } from "react";
import {
  InputSearch,
  NormalTable,
  NormalSelect,
  NormalButtonBackend,
} from "component/common";
import "../style.scss";
import { withTranslation } from "react-i18next";
import { ItemDepts } from "redux/actions/Backend";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

export class DepartmentlistClass extends Component {
  state = {
    headerDetails: [
      {
        label: "Department Code",
        divClass: "justify-content-end",
        sortKey: "Department Code",
        enabled: true,
        id: "itmCode",
        singleClickFunc: () => this.handleSort("itmCode"),
      },
      {
        label: "Description",
        sortKey: "Description",
        enabled: true,
        id: "itmDesc",
        singleClickFunc: () => this.handleSort("itmDesc"),
      },
      {
        label: "Sequence",
        divClass: "justify-content-end",
        sortKey: "Sequence",
        enabled: true,
        id: "itmSeq",
        singleClickFunc: () => this.handleSort("itmSeq"),
      },
      {
        label: "Active",
        sortKey: "Active",
        enabled: true,
        id: "itmStatus",
        singleClickFunc: () => this.handleSort("itmStatus"),
      },
    ],
    option: [
      { label: 10, value: 10 },
      { label: 25, value: 25 },
      { label: 50, value: 50 },
      { label: 100, value: 100 },
    ],
    count: 10,
    is_loading: false,
    isoption: false,
    offset: 0,
    data: [],
    perPage: 10,
    List: [],
    current_page: 1,
    seachdata: [],
    filterdata: [],
    search: "",
    pageMeta: {},
    deptList: [],
    activeButton: false,
    inactiveButton: false,
    isActive: false,
    isInactive: false,
    isAll: false,
    orderBy: "desc",
  };

  componentDidMount = () => {
    this.Listofdepts({});
  };

  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };

  /* List Sorting */
  handleSort = (sortkey) => {
    let { List, orderBy } = this.state;
    this.setState({
      orderBy: this.state.orderBy == "asc" ? "desc" : "asc",
    });
    if (orderBy === "asc") {
      List.sort((a, b) =>
        a[sortkey] > b[sortkey] ? 1 : b[sortkey] > a[sortkey] ? -1 : 0
      );
    } else {
      List.sort((a, b) =>
        a[sortkey] < b[sortkey] ? 1 : b[sortkey] < a[sortkey] ? -1 : 0
      );
    }
    this.setState({
      List,
    });
  };

  /* List of Division Function */
  Listofdepts = async () => {
    this.setState({
      is_loading: true,
      activeButton: false,
      inactiveButton: false,
    });
    await this.props.ItemDepts().then((res) => {
      let {
        deptList,
        pageCount,
        List,
        pageMeta,
        count,
        current_page,
        perPage,
      } = this.state;
      deptList = res;
      deptList.sort((a, b) => a.itmCode.localeCompare(b.itmCode));
      List = deptList.slice(
        (current_page - 1) * perPage,
        (current_page - 1) * perPage + perPage
      );
      pageCount = Math.ceil(deptList.length / this.state.perPage);
      this.setState({
        deptList,
        List,
        pageCount,
        is_loading: false,
        isActive: false,
        isInactive: false,
        isAll: true,
        pageMeta: { ...pageMeta, total_pages: pageCount, per_page: count },
      });
    });
  };

  /* List of Active Department List */
  Listofactivedept = async () => {
    this.setState({
      is_loading: true,
      activeButton: true,
      inactiveButton: false,
    });
    await this.props.ItemDepts().then((res) => {
      let { pageCount, List, current_page, perPage, pageMeta } = this.state;
      let Listone = [];
      for (let key of res) {
        if (key.itmStatus === true) {
          Listone.push({
            itmCode: key.itmCode,
            itmDesc: key.itmDesc,
            itmSeq: key.itmSeq,
            itmStatus: key.itmStatus,
          });
        }
      }
      this.setState({ Listone }, () => {
        List = Listone.slice(
          (current_page - 1) * perPage,
          (current_page - 1) * perPage + perPage
        );

        pageCount = Math.ceil(Listone.length / this.state.perPage);
        if (current_page > pageCount) {
          current_page = 1;
        }
        this.setState({
          pageCount,
          is_loading: false,
          isActive: true,
          isInactive: false,
          isAll: false,
          pageMeta: { ...pageMeta, total_pages: pageCount, current_page },
          List,
        });
      });
    });
  };

  /* List og Inactive Department List */
  Listofinactivedept = async () => {
    this.setState({
      is_loading: true,
      activeButton: false,
      inactiveButton: true,
    });
    await this.props.ItemDepts().then((res) => {
      let { pageCount, List, current_page, perPage, pageMeta } = this.state;
      let Listone = [];
      for (let key of res) {
        if (key.itmStatus === false) {
          Listone.push({
            itmCode: key.itmCode,
            itmDesc: key.itmDesc,
            itmSeq: key.itmSeq,
            itmStatus: key.itmStatus,
          });
        }
      }

      this.setState({ Listone }, () => {
        List = Listone.slice(
          (current_page - 1) * perPage,
          (current_page - 1) * perPage + perPage
        );

        pageCount = Math.ceil(Listone.length / this.state.perPage);
        if (current_page > pageCount) {
          current_page = 1;
        }
        this.setState({
          pageCount,
          is_loading: false,
          List,
          isActive: false,
          isInactive: true,
          isAll: false,
          pageMeta: { ...pageMeta, total_pages: pageCount, current_page },
        });
      });
    });
  };

  /* Select Data Limit */
  temp = ({ target: { value, name } }) => {
    let { count, perPage, pageMeta } = this.state;
    if (name == "count") {
      count = value;
      perPage = value;
      this.setState({
        count,
        perPage,
        pageMeta: { ...pageMeta, per_page: perPage },
      });
      this.Listofdepts();
    }
  };

  /* Select Page Function */
  handlePageClick = (e) => {
    let { isActive, isInactive, isAll } = this.state;
    const selectedPage = e.page;
    const offset = selectedPage * this.state.perPage;
    this.setState(
      {
        current_page: selectedPage,
        pageMeta: { ...this.state.pageMeta, current_page: selectedPage },
        offset: offset,
      },
      () => {
        if (isActive) {
          this.Listofactivedept();
        } else if (isInactive) {
          this.Listofinactivedept();
        } else if (isAll) {
          this.Listofdepts();
        } else {
          this.handleFilterChange();
        }
      }
    );
  };

  handleFilterChange = () => {
    let {
      deptList,
      filterdata,
      search,
      searchData,
      pageCount,
      perPage,
      current_page,
      pageMeta,
      activeButton,
      inactiveButton,
    } = this.state;
    if (search !== "") {
      filterdata = deptList.filter((item) => {
        const isActive = item.itmStatus ? "Yes" : "No";
        const lowerCaseSearch = search.toLowerCase();
        const lowerCaseCode = item.itmCode.toLowerCase();
        const lowerCaseDesc = item.itmDesc.toLowerCase();
        const lowerCaseSeq = String(item.itmSeq).toLowerCase();
        const lowerCaseActive = isActive.toLowerCase();
        if (activeButton && item.itmStatus === false) {
          return false;
        }
        if (inactiveButton && item.itmStatus === true) {
          return false;
        }
        return (
          lowerCaseCode.includes(lowerCaseSearch) ||
          lowerCaseDesc.includes(lowerCaseSearch) ||
          lowerCaseSeq.includes(lowerCaseSearch) ||
          lowerCaseActive.includes(lowerCaseSearch)
        );
      });
    } else {
      filterdata = deptList;
    }
    this.setState({ filterdata });
    // filterdata = deptList.filter((item) => {
    //   return Object.values(item)
    //     .join("")
    //     .toLowerCase()
    //     .includes(search.toLowerCase());
    // });

    // this.setState({ filterdata });
    searchData = filterdata.slice(
      (current_page - 1) * perPage,
      (current_page - 1) * perPage + perPage
    );
    console.log(searchData, "searchNew");
    pageCount = Math.ceil(filterdata.length / this.state.perPage);
    this.setState({
      searchData,
      pageCount,
      pageMeta: { ...pageMeta, total_pages: pageCount },
    });
  };

  //************Searching option **********//
  filterByName = ({ target: { value, name } }) => {
    let {
      deptList,
      filterdata,
      search,
      searchData,
      pageCount,
      activeButton,
      pageMeta,
      count,
      current_page,
      perPage,
      inactiveButton,
    } = this.state;
    if (name === "search") {
      search = value;
      this.setState({ search });
    }
    if (search.length === 0) {
      this.Listofdepts();
    }
    if (search !== "") {
      filterdata = deptList.filter((item) => {
        const isActive = item.itmStatus ? "Yes" : "No";
        const lowerCaseSearch = search.toLowerCase();
        const lowerCaseCode = item.itmCode.toLowerCase();
        const lowerCaseDesc = item.itmDesc.toLowerCase();
        const lowerCaseSeq = String(item.itmSeq).toLowerCase();
        const lowerCaseActive = isActive.toLowerCase();
        if (activeButton && item.itmStatus === false) {
          return false;
        }
        if (inactiveButton && item.itmStatus === true) {
          return false;
        }
        return (
          lowerCaseCode.includes(lowerCaseSearch) ||
          lowerCaseDesc.includes(lowerCaseSearch) ||
          lowerCaseSeq.includes(lowerCaseSearch) ||
          lowerCaseActive.includes(lowerCaseSearch)
        );
      });
    } else {
      filterdata = deptList;
    }
    this.setState({ filterdata });

    searchData = filterdata.slice(
      (current_page - 1) * perPage,
      (current_page - 1) * perPage + perPage
    );
    console.log(searchData, "searchData");
    pageCount = Math.ceil(filterdata.length / this.state.perPage);
    this.setState({
      searchData,
      pageCount,
      isActive: false,
      isAll: false,
      isInactive: false,
      pageMeta: { ...pageMeta, total_pages: pageCount, perPage: count },
    });
  };

  render() {
    let {
      search,
      filterdata,
      searchData,
      headerDetails,
      is_loading,
      option,
      count,
      List,
      isActive,
      isAll,
      isInactive,
      pageMeta,
    } = this.state;
    let { t } = this.props;
    return (
      <>
        <div className="container-fluid department-container bg-white">
          <div className="row">
            <div className={"itemmaster-container col-12"}>
              <div className="align-items-center">
                <div className="col-12">
                  <h4 className="label-head text-center text-md-left text-lg-left mt-3 mb-0">
                    {t("Item Classification")}
                  </h4>
                </div>
                <div className="col-12">
                  <p className="label-title text-center text-md-left text-lg-left mt-2">
                    {t("Department List")}
                  </p>
                </div>
                <div className="mt-3 col-12 d-md-flex justify-content-md-between m-0 p-0">
                  <div className="d-md-flex col-12 col-md-4">
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        isActive={isAll}
                        label={"All"}
                        onClick={this.Listofdepts}
                      />
                    </div>
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        isActive={isActive}
                        label={"Active"}
                        onClick={this.Listofactivedept}
                      />
                    </div>
                    <div className="p-1">
                      <NormalButtonBackend
                        mainbg={true}
                        isActive={isInactive}
                        label={"Inactive"}
                        onClick={this.Listofinactivedept}
                      />
                    </div>
                  </div>
                  <div className="p-1 col-12 col-md-4">
                    <InputSearch
                      type="search"
                      placeholder={t("Search")}
                      onChange={(event) =>
                        this.filterByName({
                          target: { value: event.target.value, name: "search" },
                        })
                      }
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-center justify-content-md-start col-12 mt-3">
                  <p className="mt-2 mr-1">{t("Show")}</p>
                  <div className="p-1">
                    <NormalSelect
                      options={option}
                      value={count}
                      onChange={this.temp}
                      name="count"
                    />
                  </div>
                  <p className="mt-2 ml-1">{t("Entries")}</p>
                </div>
              </div>
              <div className="tab-table-content">
                {search.length > 0 ? (
                  <div className="tab-table-content">
                    <div className="py-4">
                      <div className="table-container">
                        <NormalTable
                          headerDetails={headerDetails}
                          pageMeta={pageMeta}
                          queryHandler={(event) => this.handlePageClick(event)}
                        >
                          {is_loading ? (
                            <tr>
                              <td colSpan="7">
                                <div class="d-flex mt-5 align-items-center justify-content-center">
                                  <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ) : searchData.length > 0 ? (
                            searchData.map(
                              (
                                { itmCode, itmDesc, itmSeq, itmStatus },
                                index
                              ) => {
                                return (
                                  <tr key={index}>
                                    <td>
                                      <div
                                        className="text-left text-primary"
                                        onClick={() =>
                                          this.props.history.push(
                                            `/admin/backend/departmentId/${itmCode}`
                                          )
                                        }
                                      >
                                        {itmCode}
                                      </div>
                                    </td>
                                    <td>
                                      <div className="text-left">{itmDesc}</div>
                                    </td>
                                    <td>
                                      <div className="text-left">{itmSeq}</div>
                                    </td>
                                    <td>
                                      <div className="text-left">
                                        {itmStatus == true ? "Yes" : "No"}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }
                            )
                          ) : null}
                        </NormalTable>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="py-4">
                    <div className="table-container">
                      <NormalTable
                        headerDetails={headerDetails}
                        pageMeta={pageMeta}
                        queryHandler={(event) => this.handlePageClick(event)}
                      >
                        {is_loading ? (
                          <tr>
                            <td colSpan="7">
                              <div class="d-flex mt-5 align-items-center justify-content-center">
                                <div class="spinner-border" role="status">
                                  <span class="sr-only">Loading...</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ) : List.length > 0 ? (
                          List.map(
                            (
                              { itmCode, itmDesc, itmSeq, itmStatus },
                              index
                            ) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <div
                                      className="text-left text-primary"
                                      onClick={() =>
                                        this.props.history.push(
                                          `/admin/backend/departmentId/${itmCode}`
                                        )
                                      }
                                    >
                                      {itmCode}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="text-left">{itmDesc}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">{itmSeq}</div>
                                  </td>
                                  <td>
                                    <div className="text-left">
                                      {itmStatus == true ? "yes" : "No"}
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )
                        ) : null}
                      </NormalTable>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="icon"
                onClick={() =>
                  this.props.history.push(
                    `/admin/backend/itemclassification/departmentdataentry`
                  )
                }
              >
                +
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ItemDepts,
    },
    dispatch
  );
};

export const Departmentlist = withTranslation()(
  connect(null, mapDispatchToProps)(DepartmentlistClass)
);
